import axios from 'axios';

//TODO set some global communication defaults. E.G. content-type: json headers, etc.

/*
 *  MANAGED TRIP SINGLE PAGE APPLICATION API FUNCTIONS
 */
export function findTrip(recordLocator, lastName, recaptchaResponse) {
    return axios.get(`${process.env.VUE_APP_MT_API_SPA_URL}/trip/find?recordLocator=${recordLocator}&lastName=${lastName}&recaptchaResponse=${recaptchaResponse}`);
}

export function getTrip(tripId, tripTinyHash, targetLinkId) {
    let route = `${process.env.VUE_APP_MT_API_SPA_URL}/trip/${tripId}/${tripTinyHash}`;

    if (targetLinkId != '') {
        route = `${route}/${targetLinkId}`;
    }

    return axios.get(route);
}

export function getTripAndLink(tripId, linkId, linkTinyHash) {
    return axios.get(`${process.env.VUE_APP_MT_API_SPA_URL}/trip/${tripId}/link/${linkId}/${linkTinyHash}`);
}

export function completePayment(tripId, linkId, linkTinyHash, formOfPayments) {
     return axios.post(`${process.env.VUE_APP_MT_API_SPA_URL}/payment/${tripId}/link/${linkId}/${linkTinyHash}`, {formOfPayments: formOfPayments}, {
        headers: {
            'Content-Type': 'application/json'
        },
    });
}

/*
 *  MANAGED TRIP API FUNCTIONS
 */
export function getCountries() {
    return axios.get(`${process.env.VUE_APP_MT_BASE_PUBLIC_URL}/country/search?query=`);
}